<template>
  <div class="w-full">
    <div class="w-full relative">
      <div class="lg:pt-24 md:pt-20 pt-20 pb-8 lg:px-20 md:px-10 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Join Us</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16"
          >Partner With Us</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
      <img
        src="../../../assets/images/joinus-bg.png"
        alt="bg"
        class="w-full cvr-img-ht2"
      />
      <!-- <p class="text-black covertext absolute">Partner With Us</p> -->
      <div class="text-black covertext absolute lg:w-9/12 md:w-10/12 lg:mt-2 md:mt-6 w-full">
        <h2 class="text-center text-black font-semibold fsize35">
          Partner with us as a
        </h2>
        <div
          class="grid lg:grid-cols-5 md:grid-cols-3 grid-cols-3 lg:gap-15 md:gap-6 gap-5 lg:px-0 md:px-0 px-5 justify-center items-center pt-4 text-center"
        >
          <p
            @click="handlevol()"
            class="onhoverul cursor-pointer text-primary fsize16"
          >
            Volunteer
          </p>
          <p
            @click="handleBecomeVol()"
            class="onhoverul cursor-pointer text-primary fsize16"
          >
            Become a vendor
          </p>
          <p
            @click="handledon()"
            class="onhoverul cursor-pointer text-primary fsize16"
          >
            Employee
          </p>

          <!-- <p
            @click="handledon()"
            class="onhoverul cursor-pointer text-primary fsize20"
          >
            Donor
          </p>
          <p
            @click="handlecar()"
            class="onhoverul cursor-pointer text-primary fsize20"
          >
            Career
          </p>
          <p
            @click="handleinter()"
            class="onhoverul cursor-pointer text-primary fsize20"
          >
            Intern
          </p> -->
          <p
            @click="handlepart()"
            class="onhoverul cursor-pointer text-primary fsize16"
          >
            Partner
          </p>
          <p
            @click="handleinter()"
            class="onhoverul cursor-pointer text-primary fsize16"
          >
            Care Attendant
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handlevol() {
      const el = document.getElementById("joinvolunteer");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handledon() {
      const el = document.getElementById("joindonor");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handlecar() {
      const el = document.getElementById("joincareers");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handleinter() {
      const el = document.getElementById("internjoin");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handlepart() {
      const el = document.getElementById("joinpartner");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handleBecomeVol() {
      window.open(
        "https://forms.office.com/pages/responsepage.aspx?id=lcGeG5WwKUiTdeSkhOjXTslLosrrE6lCpOewLSu3lLNUNFFaR1hVRDhNRjdOOERXQlM2MFdZRkpaNC4u&origin=lprLink"
      );
    },
  },
  async mounted() {
    // console.log(this.$route.query);
    if (this.$route.query.partner == true) {
      await this.handlepart();
      const el = document.getElementById("joinpartner");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  },
};
</script>
